export const API_URL = "https://k8sbackend.bns.co.kr";
